module.exports = __webpack_public_path__ + "img/add_btn_icon121.9dbb9739.svg";